import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@src/app/shared/shared.module';
import { AddressInfoMobileComponent } from '@src/app/standalone-components/address-info-mobile/address-info-mobile.component';
import { AddressInfoComponent } from '@src/app/standalone-components/address-info/address-info.component';
import { AddressAssetTransactionComponent } from '@src/app/standalone-components/address/address-asset-transaction/address-asset-transaction.component';
import { FollowBtnComponent } from '@src/app/standalone-components/follow-btn/follow-btn.component';
import { PeopleYouMayKnowComponent } from '@src/app/standalone-components/people-you-may-know/people-you-may-know.component';
import { UserCardComponent } from '@src/app/standalone-components/user-card/user-card.component';
import { AddressDetailComponent } from './address-detail/address-detail.component';
import { AddressRoutingModule } from './address-routing.module';
import { AddressService } from './address.service';
import { FollowListComponent } from './follow-list/follow-list.component';

@NgModule({
    declarations: [AddressDetailComponent, FollowListComponent],
    providers: [AddressService],
    imports: [
        CommonModule,
        AddressRoutingModule,
        SharedModule,
        FollowBtnComponent,
        UserCardComponent,
        AddressAssetTransactionComponent,
        PeopleYouMayKnowComponent,
        AddressInfoComponent,
        AddressInfoMobileComponent,
    ],
})
export class AddressModule {}
